import useApiMutation from '_api/mutations/useApiMutation';
import { Guardian, GuardianPayload } from '_api/types';

export const CREATE_GUARDIAN_WITH_PATIENT = 'create-guardian-with-patient';

export const useCreateGuardianWithPatient = () => {
  return useApiMutation<Guardian, GuardianPayload>(
    () => `/guardian/create`,
    'post',
    {},
    {
      mutationKey: [CREATE_GUARDIAN_WITH_PATIENT],
    },
    (body: GuardianPayload) => JSON.stringify(body),
  );
};
